import { Component, ElementRef, Inject, ViewChild, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidadoresService } from '../../services/validadores.service';
import { DatosProcesarFirma } from '../../Models/Proceso-Firma-Datos.models';
import { FirmaDigitalService } from '../../services/firma-digital.service';

@Component({
  selector: 'app-firmar',
  templateUrl: './firmar.component.html',
  styleUrls: ['./firmar.component.css']
})
export class FirmarComponent {

  @ViewChild("datos") divDatos!: ElementRef;
  @ViewChild("error") divError!: ElementRef;
  @ViewChild("firmar") divFirmar!: ElementRef;
  @ViewChild("action") divAction!: ElementRef;

  form: FormGroup;
  titulo: string = 'Validación de datos para firmar';
  rut: string = '';

  constructor(public dialogRef: MatDialogRef<FirmarComponent>, @Inject(MAT_DIALOG_DATA) public data: DatosProcesarFirma, 
            private fb: FormBuilder, private renderer: Renderer2, private validarService: ValidadoresService,
            private firmaDigitalService: FirmaDigitalService) {
    dialogRef.disableClose = true; 
    
    this.form = this.fb.group({
      rut: ['', [Validators.required, Validators.maxLength(10)]],
      token: ['', Validators.required]
    }, {
      validators: this.validarService.validarRut('rut')
    });
  }

  get rutNoValido() {
    return this.form.get('rut')?.invalid && this.form.get('rut')?.touched
  }

  get tokenNoValido() {
    return this.form.get('token')?.invalid && this.form.get('token')?.touched
  }

  salir(){
    this.dialogRef.close('');
  }

  volver() {
    this.titulo = 'Validación de datos para firmar';
    this.renderer.removeClass(this.divDatos.nativeElement, 'ocultar');
    this.renderer.removeClass(this.divAction.nativeElement, 'ocultar');
    this.renderer.addClass(this.divError.nativeElement, 'ocultar');
  }

  validar() {
    this.renderer.addClass(this.divDatos.nativeElement, 'ocultar');
    this.renderer.addClass(this.divAction.nativeElement, 'ocultar');

    if (this.rut !== this.form.get('rut').value) {
      this.form.controls['rut'].setValue(this.rut);
    }
    
    let valido = (this.data._rut.toUpperCase() === this.form.get('rut').value.toUpperCase() && this.data._hashFirma === this.form.get('token').value);

    if (valido) {
      this.titulo = 'Incorporar firma digital';
      this.renderer.removeClass(this.divFirmar.nativeElement, 'ocultar');
    } else {
      this.titulo = 'Error de validación';
      this.renderer.removeClass(this.divError.nativeElement, 'ocultar');
    }
  }

  firmarDocumento() {
    this.firmaDigitalService.firmarDocumento(this.data).subscribe(response => {
      if (response.ejecucionTarea) {
        this.dialogRef.close('firmado');
      } else {
        this.dialogRef.close('error');
      }
    }, err => {
      this.dialogRef.close('error');
    });
  }

  formatoRUT(event: any) {
    let value = event.target.value.replace(/\./g, '').replace('-', '');

    if (value.match(/^(\d{7,8}){1}(\w{1})$/)) {
         value = value.replace(/^(\d{7,8})(\w{1})$/, '$1-$2');
    }
    this.rut = value;
  }
}
